export default {
  method_unavailable: 'Denne betalingsmetode er ikke tilgængelig lige nu. Vælg en anden.',
  payment_option_unavailable: 'Denne betalingsmulighed er ikke tilgængelig lige nu. Vælg en anden betalingsmåde.',
  online_payment_unavailable: 'Onlinebetaling er ikke tilgængelig lige nu. Prøv igen om et øjeblik.',
  retry_payment_methods: 'Prøv igen',
  payment_not_ready: 'Din betaling forberedes stadig. Prøv igen om et øjeblik.',
  wallet_total_changed: 'Totalbeløbet for denne betalingsmetode er ændret. Tjek det, og tryk på knappen igen.',
  wallet_tap_above: 'Tryk på knappen {{method}} ovenfor for at betale, eller vælg en anden betalingsmetode.',
  wallet_pay_above: 'Brug knappen {{method}} ovenfor',
  element_incomplete: 'Udfyld dine betalingsoplysninger for at fortsætte.',
  element_incomplete_card: 'Tjek dine kortoplysninger, og prøv igen.',
  element_incomplete_bank: 'Vælg din bank for at fortsætte.',
  element_incomplete_sepa_debit: 'Tjek dit IBAN og kontoindehaverens oplysninger for at fortsætte.',
};
